import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ClinicalNotesLoggedTable from 'components/molecules/clinical-notes-logged';
import { currentMonthRange } from 'infrastructure/consts/current-month-range';
import DraggableModal from 'components/organisms/draggableModal';
import { ModuleType } from 'infrastructure/enums';
import { useSelector } from 'react-redux';

import s from './styles.module.scss';

import type { RootState } from 'store';

interface IProps {
  patientGuid: string;
  isOpen: boolean;
  onCancel: () => void;
}

const ClinicalNotesModal: React.FC<IProps> = ({
  patientGuid,
  isOpen,
  onCancel,
}) => {
  if (!isOpen) return <></>;

  const { t } = useTranslation();

  const { conversationType } = useSelector(
    (state: RootState) => state.smsDashboard,
  );

  const module = useMemo(() => {
    if (conversationType.includes(ModuleType.CCM)) return ModuleType.CCM;

    return ModuleType.RPM;
  }, [conversationType]);

  return (
    <DraggableModal
      title={t('labels.clinicalNotesLogged')}
      isOpen={isOpen}
      toggle={onCancel}
      modalClassName={s.modal}
      bodyClassName={s.body}
      footer={<></>}
    >
      <ClinicalNotesLoggedTable
        patientGuid={patientGuid}
        showTabs
        dateRange={currentMonthRange}
        module={module}
      />
    </DraggableModal>
  );
};

export default ClinicalNotesModal;
